document.addEventListener("DOMContentLoaded", () => {

  const root = document.querySelector(".to-pace-calc");

  if (!root) {
    return;
  }

  const modeTabs = root.querySelectorAll(".to-tab");
  const modePanels = root.querySelectorAll(".to-mode-panel");

  const resultBox = document.getElementById("toResult");
  const outputGrid = document.getElementById("toOutputGrid");

  const outPace = document.getElementById("toOutPace");
  const outTime = document.getElementById("toOutTime");
  const outSpeed = document.getElementById("toOutSpeed");

  const raceWrap = document.getElementById("toRaceTableWrap");
  const raceTable = document.getElementById("toRaceTable");

  const splitWrap = document.getElementById("toSplitTableWrap");
  const splitTable = document.getElementById("toSplitTable");

  let currentMode = "time-to-pace";

  function setMode(mode) {

    currentMode = mode;

    modeTabs.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.mode === mode);
    });

    modePanels.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.panel !== mode);
    });
  }

  modeTabs.forEach(tab => {
    tab.addEventListener("click", () => {
      setMode(tab.dataset.mode);
    });
  });

  function getDistance() {

    const val = parseFloat(document.getElementById("toDistance").value);

    if (!val || val <= 0) {
      alert("Syötä matka kilometreinä.");
      return null;
    }

    return val;
  }

  function formatTime(totalSeconds) {

    totalSeconds = Math.round(totalSeconds);

    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    if (h > 0) {
      return `${h} h ${m} min ${s} s`;
    }

    return `${m} min ${s} s`;
  }

  function formatPace(secPerKm) {

    const min = Math.floor(secPerKm / 60);
    const sec = Math.round(secPerKm % 60);

    return `${min}:${String(sec).padStart(2, "0")} min/km`;
  }

  function showOutputs(pace, time, speed) {

    outPace.textContent = pace;
    outTime.textContent = time;
    outSpeed.textContent = speed;

    outputGrid.hidden = false;
  }

  function renderRaceTable(secPerKm) {

    const races = [
      ["5 km", 5],
      ["10 km", 10],
      ["Puolimaraton", 21.0975],
      ["Maraton", 42.195]
    ];

    raceTable.innerHTML = "";

    races.forEach(race => {

      const total = secPerKm * race[1];

      raceTable.innerHTML += `
        <tr>
          <td>${race[0]}</td>
          <td>${formatTime(total)}</td>
        </tr>
      `;
    });

    raceWrap.hidden = false;
  }

  function renderSplitTable(distance, secPerKm) {

    splitTable.innerHTML = "";

    for (let i = 1; i <= Math.floor(distance); i++) {

      splitTable.innerHTML += `
        <tr>
          <td>${i} km</td>
          <td>${formatTime(i * secPerKm)}</td>
        </tr>
      `;
    }

    splitWrap.hidden = false;
  }

  document.getElementById("toCalcPace").addEventListener("click", () => {

    const distance = getDistance();
    if (!distance) return;

    const h = parseInt(document.getElementById("toHours").value || 0);
    const m = parseInt(document.getElementById("toMinutes").value || 0);
    const s = parseInt(document.getElementById("toSeconds").value || 0);

    const totalSeconds = (h * 3600) + (m * 60) + s;

    if (totalSeconds <= 0) {
      alert("Syötä tavoiteaika.");
      return;
    }

    const secPerKm = totalSeconds / distance;
    const speed = 3600 / secPerKm;

    resultBox.innerHTML = `
      <span>Tulos</span>
      <p>Tavoitevauhtisi on ${formatPace(secPerKm)}.</p>
    `;

    showOutputs(
      formatPace(secPerKm),
      formatTime(totalSeconds),
      `${speed.toFixed(1)} km/h`
    );

    renderRaceTable(secPerKm);
    renderSplitTable(distance, secPerKm);
  });

  document.getElementById("toCalcTime").addEventListener("click", () => {

    const distance = getDistance();
    if (!distance) return;

    const paceMin = parseInt(document.getElementById("toPaceMin").value || 0);
    const paceSec = parseInt(document.getElementById("toPaceSec").value || 0);

    const secPerKm = (paceMin * 60) + paceSec;

    if (secPerKm <= 0) {
      alert("Syötä vauhti.");
      return;
    }

    const totalSeconds = secPerKm * distance;
    const speed = 3600 / secPerKm;

    resultBox.innerHTML = `
      <span>Tulos</span>
      <p>Arvioitu loppuaikasi on ${formatTime(totalSeconds)}.</p>
    `;

    showOutputs(
      formatPace(secPerKm),
      formatTime(totalSeconds),
      `${speed.toFixed(1)} km/h`
    );

    renderRaceTable(secPerKm);
    renderSplitTable(distance, secPerKm);
  });

  document.getElementById("toCalcSpeed").addEventListener("click", () => {

    const speed = parseFloat(document.getElementById("toSpeed").value);

    if (!speed || speed <= 0) {
      alert("Syötä keskinopeus.");
      return;
    }

    const secPerKm = 3600 / speed;

    resultBox.innerHTML = `
      <span>Tulos</span>
      <p>Juoksuvauhtisi on ${formatPace(secPerKm)}.</p>
    `;

    showOutputs(
      formatPace(secPerKm),
      "–",
      `${speed.toFixed(1)} km/h`
    );

    renderRaceTable(secPerKm);
  });

  document.getElementById("toReset").addEventListener("click", () => {

    root.querySelectorAll("input").forEach(input => {
      input.value = "";
    });

    resultBox.innerHTML = `
      <span>Tulos</span>
      <p>Valitse matka ja syötä aika, vauhti tai keskinopeus.</p>
    `;

    outputGrid.hidden = true;
    raceWrap.hidden = true;
    splitWrap.hidden = true;
  });

  root.querySelectorAll(".to-distance-buttons button").forEach(btn => {

    btn.addEventListener("click", () => {

      document.getElementById("toDistance").value = btn.dataset.distance;

      root.querySelectorAll(".to-distance-buttons button").forEach(b => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
    });
  });

  root.querySelectorAll(".to-time-buttons button").forEach(btn => {

    btn.addEventListener("click", () => {

      document.getElementById("toHours").value = btn.dataset.h;
      document.getElementById("toMinutes").value = btn.dataset.m;
      document.getElementById("toSeconds").value = btn.dataset.s;

      root.querySelectorAll(".to-time-buttons button").forEach(b => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
    });
  });

  root.querySelectorAll(".to-pace-buttons button").forEach(btn => {

    btn.addEventListener("click", () => {

      document.getElementById("toPaceMin").value = btn.dataset.pm;
      document.getElementById("toPaceSec").value = btn.dataset.ps;

      root.querySelectorAll(".to-pace-buttons button").forEach(b => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
    });
  });

  root.querySelectorAll(".to-speed-buttons button").forEach(btn => {

    btn.addEventListener("click", () => {

      document.getElementById("toSpeed").value = btn.dataset.speed;

      root.querySelectorAll(".to-speed-buttons button").forEach(b => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
    });
  });

});
